// extracted by mini-css-extract-plugin
export default {"fullWidth":"tm-z","image":"um-z","lazyLoadPicture":"vm-z","lazyLoadSpinner":"wm-z","lazyLoadSpin":"xm-z","lazyLoadImage":"ym-z","hasStyledAspectRatio":"zm-z"};